// 菜单配置
import _ from 'underscore'
import clone from 'clone'

// 框架页
import Index from '../views/Index.vue'

// 组件列表
const components = {
	// 仪表盘
	Dashboard: () => import('../views/dashboard/Index.vue'),

	//app应用市场管理
	AppStore: () => import('../views/app/AppStore.vue'),

	//app应用管理
	App: () => import('../views/app/App.vue'),

	//app版本管理
	AppVersion: () => import('../views/app/AppVersion.vue'),

	//app广告管理
	AppAdvert: () => import('../views/app/AppAdvert.vue'),

	//app应用外链
	AppFuncs: () => import('../views/app/AppFuncs.vue'),

	//广告商管理
	AdvertSupplier: () => import('../views/advert/AdvertSupplier.vue'),

	//广告商广告管理
	SupplierAdvert: () => import('../views/advert/SupplierAdvert.vue'),

	//咨询商管理
	NewsSupplier: () => import('../views/advert/NewsSupplier.vue'),

	//咨询商咨询管理
	NewsOption: () => import('../views/advert/NewsOption.vue'),

	//自有广告管理
	InnerAdvert: () => import('../views/advert/InnerAdvert.vue'),

	//意见反馈管理
	Advice: () => import('../views/advice/Advice.vue'),



	//神农提现审核
	CheckData: () => import('../views/check/CheckData.vue'),
	//新看点提现审核
	NewVideoCheckData: () => import('../views/check/NewVideoCheckData.vue'),

	//一级分类统计
	PageData: () => import('../views/datacount/click/PageData.vue'),

	//二级分类统计
	EventData: () => import('../views/datacount/click/EventData.vue'),

	//广告数据统计
	AdvertData: () => import('../views/datacount/advert/AdvertData.vue'),

	//日历图片管理
	DayPic: () => import('../views/daypic/DayPic.vue'),
	//天气会员明细
	Member: () => import('../views/member/Member.vue'),

	//点灯配置
	LightConfig: () => import('../views/light/LightConfig.vue'),
	//点灯配置
	LightOrder: () => import('../views/light/Order.vue'),


	//兼职配置
	JobConfig: () => import('../views/job/JobConfig.vue'),
	QingTuanJob: () => import('../views/job/QingTuanJob.vue'),
	JobMaoConfig: () => import('../views/job/JobMaoConfig.vue'),
	JobRecommand: () => import('../views/job/JobRecommand.vue'),
	//报名记录
	JoinJob: () => import('../views/job/JoinJob.vue'),
	JobChannel: () => import('../views/job/JobChannel.vue'),
	JobCount: () => import('../views/job/JobCount.vue'),
	UserPushJobCheck: () => import('../views/job/UserPushJobCheck.vue'),
	UserPushCompanyCheck: () => import('../views/job/UserPushCompanyCheck.vue'),
	Merchant: () => import('../views/job/Merchant.vue'),
	User: () => import('../views/job/User.vue'),
	PayRecord: () => import('../views/job/PayRecord.vue'),
	DrawRecord: () => import('../views/job/DrawRecord.vue'),
	//记账本
	CashBook: () => import('../views/cashbook/CashBook.vue'),
	//banner
	Banner: () => import('../views/banner/Banner.vue'),

	//校园直聘
	SchoolJob: () => import('../views/schoolJob/SchoolJob.vue'),
	SchoolJobImg: () => import('../views/schoolJob/SchoolJobImg.vue'),
	SchoolJobPost: () => import('../views/schoolJob/SchoolJobPost.vue'),
	AdvertImg: () => import('../views/schoolJob/AdvertImg.vue'),
	ResumeTemplate: () => import('../views/schoolJob/ResumeTemplate.vue'),
	GoodCatalog: () => import('../views/schoolJob/GoodCatalog.vue'),
	MemberOrder: () => import('../views/schoolJob/MemberOrder.vue'),
	GoodOrder: () => import('../views/schoolJob/GoodOrder.vue'),
}

// 菜单配置
// 同vue router配置一致，除了下面二项，会根据配置自动生成路由和面包屑导航。
// 1：为添加菜单栏目，增加list数组属性，包含路由配置或子栏目，但不可包含path属性：
// path: '', 此属性不要为菜单栏目配置，请仅为有路由的菜单项配置
// meta: {
//   label: '栏目名称',
//   customIcon: '栏目图标'
// },
// list: [{路由配置},...]
// 2：在meta元数据中添加额外属性：
// - label: 菜单项名称
// - customIcon: iconfont图标
// - auth: 菜单项权限码
// - hide: 是否在菜单列表中隐藏
// - keepAlive: 视图是否常驻内存
// - homepage: 首页地址，以最后定义的为准
const menus = [{
	meta: {
		label: '仪表盘',
		customIcon: 'iconfont icon-dashboard',
	},
	list: [{
		path: '/dashboard/analysis',
		component: components.Dashboard,
		meta: {
			label: '分析页',
			homePage: true,
			keepAlive: true
		}
	}]
}]

// 生成路由
const generateRoute = (menus) => {
	let menusRouter = []
	let homePage = ''
	const handleRoute = (menus) => {
		_.each(menus, (item) => {
			if (item.path) {
				menusRouter.push(item)
				if (item.meta.homePage) {
					homePage = item.path
				}
			}
			if (item.list && item.list.length) {
				handleRoute(item.list)
			}
		})
	}
	handleRoute(clone(menus))
	menusRouter.push({
		path: '',
		redirect: homePage
	})
	return [{
		path: '/',
		component: Index,
		children: menusRouter
	}]
}

// 生成菜单
const handleMenus = (menus, oldMenus = [], userType) => {
	if (!menus.length) {
		return {
			menus: oldMenus,
			permission: []
		}
	}
	console.log(userType)
	const newMenus = []
	const permission = []
	const recursion = function(menus, newMenus) {
		const dataLength = menus.length
		for (let i = 0; i < dataLength; i++) {
			const item = menus[i]
			if (userType === '1') {
				if (item.type === 2) { // btn
					if (item.perms) {
						permission.push({
							name: item.parentName + '-' + item.name,
							auth: item.perms,
							path: item.url,
							component: item.component
						})
					}
					if (item.url && item.component && components[item.component]) {
						newMenus.push({
							meta: {
								label: item.name || '',
								auth: item.perms || '',
								hide: true
							},
							path: item.url,
							component: components[item.component]
						})
					}
				} else { // menu
					const newItem = {
						meta: {
							label: item.name || '',
							customIcon: item.iconfont ? 'iconfont ' + item.iconfont : '',
							icon: item.icon ? item.icon : '',
							auth: item.perms || '',
							hide: !!item.hidden
						}
					}
					if (item.list && item.list.length) {
						newItem.list = []
						recursion(item.list, newItem.list)
					}
					if (item.url && item.component && components[item.component]) {
						newItem.path = item.url
						newItem.component = components[item.component]
					}
					newMenus.push(newItem)
				}

			}
			if (userType === '2') {
				if (item.userType === '2') {
					if (item.type === 2) { // btn
						if (item.perms) {
							permission.push({
								name: item.parentName + '-' + item.name,
								auth: item.perms,
								path: item.url,
								component: item.component
							})
						}
						if (item.url && item.component && components[item.component]) {
							newMenus.push({
								meta: {
									label: item.name || '',
									auth: item.perms || '',
									hide: true
								},
								path: item.url,
								component: components[item.component]
							})
						}
					} else { // menu
						const newItem = {
							meta: {
								label: item.name || '',
								customIcon: item.iconfont ? 'iconfont ' + item.iconfont : '',
								icon: item.icon ? item.icon : '',
								auth: item.perms || '',
								hide: !!item.hidden
							}
						}
						if (item.list && item.list.length) {
							newItem.list = []
							recursion(item.list, newItem.list)
						}
						if (item.url && item.component && components[item.component]) {
							newItem.path = item.url
							newItem.component = components[item.component]
						}
						newMenus.push(newItem)
					}
				}


			}
		}
	}
	recursion(menus, newMenus)
	return {
		menus: oldMenus.concat(newMenus),
		permission: permission
	}
}

// fixed menus
const fixedMenus = [
	{
		menuId: 2,
		parentId: 0,
		parentName: null,
		name: '应用管理',
		url: '',
		perms: null,
		type: 1,
		level: 1,
		icon: 'md-cube',
		orderNum: 0,
		list: [{
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: '应用市场管理',
				url: '/app/appStore',
				perms: null,
				type: 1,
				level: 1,
				icon: 'ios-cart',
				orderNum: 0,
				component: 'AppStore',

			},
			{
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: 'app应用管理',
				url: '/app',
				perms: null,
				type: 1,
				level: 1,
				icon: 'ios-pricetags',
				orderNum: 0,
				component: 'App',

			},
			{
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: 'app版本管理',
				url: '/app/version',
				perms: null,
				type: 1,
				level: 1,
				icon: 'md-flag',
				orderNum: 0,
				hidden: true,
				component: 'AppVersion',
			},
			{
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: 'app广告管理',
				url: '/app/advert',
				perms: null,
				type: 1,
				level: 1,
				icon: 'md-flag',
				orderNum: 0,
				hidden: true,
				component: 'AppAdvert',
			},
			{
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: '功能外链',
				url: '/app/funcs',
				perms: null,
				type: 1,
				level: 1,
				icon: 'ios-pricetags',
				orderNum: 0,
				hidden: true,
				component: 'AppFuncs',
			},
		]

	},
	{
		menuId: 2,
		parentId: 0,
		parentName: null,
		name: '广告资讯',
		url: '',
		perms: null,
		type: 1,
		level: 1,
		icon: 'ios-desktop',
		orderNum: 0,
		list: [{
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: '广告供应商',
				url: '/advert/supplier',
				perms: null,
				type: 1,
				level: 1,
				icon: 'md-people',
				orderNum: 0,
				component: 'AdvertSupplier',
				list: [{
					menuId: 2,
					parentId: 0,
					parentName: null,
					name: '供应商广告',
					url: '/supplier/advert',
					perms: null,
					type: 1,
					level: 1,
					icon: 'md-flag',
					orderNum: 0,
					hidden: true,
					component: 'SupplierAdvert',
				}, ]
			}, {
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: '资讯供应商',
				url: '/supplier/news',
				perms: null,
				type: 1,
				level: 1,
				icon: 'md-people',
				orderNum: 0,
				component: 'NewsSupplier',
				list: [{
					menuId: 2,
					parentId: 0,
					parentName: null,
					name: '供应商广告',
					url: '/supplier/news/option',
					perms: null,
					type: 1,
					level: 1,
					icon: 'md-flag',
					orderNum: 0,
					hidden: true,
					component: 'NewsOption',
				}]
			},
			{
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: '自有广告',
				url: '/inner/advert',
				perms: null,
				type: 1,
				level: 1,
				icon: 'md-easel',
				orderNum: 0,
				component: 'InnerAdvert',
			},

		]
	},
	{
		menuId: 2,
		parentId: 0,
		parentName: null,
		name: '意见反馈',
		url: '/advice',
		perms: null,
		type: 1,
		level: 1,
		icon: 'md-mail-open',
		orderNum: 0,
		component: 'Advice',
	},
	{
		menuId: 2,
		parentId: 0,
		parentName: null,
		name: '提现审核',
		url: '',
		perms: null,
		type: 1,
		level: 1,
		icon: 'ios-desktop',
		orderNum: 0,
		list: [{
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '神农',
			url: '/sn/drawCheck',
			perms: null,
			type: 1,
			level: 1,
			icon: 'md-mail-open',
			orderNum: 0,
			component: 'CheckData',
		}, {
			menuId: 3,
			parentId: 0,
			parentName: null,
			name: '新看点',
			url: '/newvideo/drawCheck',
			perms: null,
			type: 1,
			level: 1,
			icon: 'md-mail-open',
			orderNum: 0,
			component: 'NewVideoCheckData',
		}, ]
	},
	{
		menuId: 2,
		parentId: 0,
		parentName: null,
		name: '数据统计',
		url: '',
		perms: null,
		type: 1,
		level: 1,
		icon: 'ios-pricetags',
		orderNum: 0,
		list: [{
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '广告统计',
			url: '/datacount/advert',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'AdvertData'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '点击统计',
			url: '',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			list: [{
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: '一级分类',
				url: '/datacount/page',
				perms: null,
				type: 1,
				level: 1,
				icon: 'md-flag',
				orderNum: 0,
				component: 'PageData',
			}, {
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: '二级分类',
				url: '/datacount/event',
				perms: null,
				type: 1,
				level: 1,
				icon: 'md-flag',
				orderNum: 0,
				component: 'EventData',
			}]
		}]
	},
	{
		menuId: 2,
		parentId: 0,
		parentName: null,
		name: 'Banner管理',
		url: '/banner',
		perms: null,
		type: 1,
		level: 1,
		icon: 'md-mail-open',
		orderNum: 0,
		component: 'Banner',
	},
	{
		menuId: 2,
		parentId: 0,
		parentName: null,
		name: '日历图片管理',
		url: '/daypic',
		perms: null,
		type: 1,
		level: 1,
		icon: 'md-mail-open',
		orderNum: 0,
		component: 'DayPic',
	},
	{
		menuId: 2,
		parentId: 0,
		parentName: null,
		name: '天气会员明细',
		url: '/member',
		perms: null,
		type: 1,
		level: 1,
		icon: 'md-mail-open',
		orderNum: 0,
		component: 'Member',
	},
	{
		menuId: 2,
		parentId: 0,
		parentName: null,
		name: '点灯管理',
		url: '',
		perms: null,
		type: 1,
		level: 1,
		icon: 'ios-pricetags',
		orderNum: 0,
		list: [{
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '点灯配置',
			url: '/light',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'LightConfig'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '订单记录',
			url: '/lightOrder',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'LightOrder'
		}]
	},
	{
		menuId: 2,
		parentId: 0,
		parentName: null,
		name: '兼职直聘',
		userType: '2',
		url: '',
		perms: null,
		type: 1,
		level: 1,
		icon: 'ios-pricetags',
		orderNum: 0,
		list: [{
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '用户发布',
			userType: '2',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			list: [{
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: '岗位审核',
				userType: '2',
				url: '/userPushJobCheck',
				perms: null,
				type: 1,
				level: 1,
				icon: 'ios-pricetags',
				orderNum: 0,
				component: 'UserPushJobCheck'
			}, {
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: '企业审核',
				userType: '2',
				url: '/userPushCompanyCheck',
				perms: null,
				type: 1,
				level: 1,
				icon: 'ios-pricetags',
				orderNum: 0,
				component: 'UserPushCompanyCheck'
			}, {
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: '支付记录',
				userType: '2',
				url: '/payRecord',
				perms: null,
				type: 1,
				level: 1,
				icon: 'ios-pricetags',
				orderNum: 0,
				component: 'PayRecord'
			}]
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: 'C端用户',
			url: '/user',
			userType: '2',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'User'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '自营发布商户认证',
			url: '/merchant',
			userType: '2',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'Merchant'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '兼职猫岗位',
			url: '/jobMaoConfig',
			userType: '2',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'JobMaoConfig'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '自营岗位',
			url: '/jobConfig',
			perms: null,
			userType: '2',
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'JobConfig'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '青团岗位',
			url: '/qingTuan',
			perms: null,
			userType: '2',
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'QingTuanJob'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '提现记录',
			url: '/drawRecord',
			perms: null,
			userType: '2',
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'DrawRecord'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '报名记录',
			userType: '2',
			url: '/joinJob',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'JoinJob'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '数据统计',
			userType: '2',
			url: '',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			list: [{
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: '渠道管理',
				url: '/jobChannel',
				userType: '2',
				perms: null,
				type: 1,
				level: 1,
				icon: 'ios-pricetags',
				orderNum: 0,
				component: 'JobChannel'
			}, {
				menuId: 2,
				parentId: 0,
				parentName: null,
				name: '渠道统计',
				url: '/jobCount',
				userType: '2',
				perms: null,
				type: 1,
				level: 1,
				icon: 'ios-pricetags',
				orderNum: 0,
				component: 'JobCount'
			}]
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '职位推荐',
			url: '/jobRecommand',
			perms: null,
			userType: '2',
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'JobRecommand'
		}]
	},
	{
		menuId: 2,
		parentId: 0,
		parentName: null,
		name: '校园直聘',
		userType: '2',
		url: '',
		perms: null,
		type: 1,
		level: 1,
		icon: 'ios-pricetags',
		orderNum: 0,
		list: [{
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '企业管理',
			url: '/schoolJob',
			userType: '2',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'SchoolJob'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			userType: '2',
			name: '图片管理',
			url: '/schoolJobImg',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'SchoolJobImg'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			userType: '2',
			name: '岗位管理',
			url: '/schoolJobPost',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'SchoolJobPost'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '广告图管理',
			userType: '2',
			url: '/advertImg',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'AdvertImg',
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '简历模板',
			userType: '2',
			url: '/resumeTemplate',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'ResumeTemplate'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '商品管理',
			userType: '2',
			url: '/goodCatalog',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'GoodCatalog'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '商品订单',
			userType: '2',
			url: '/goodOrder',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'GoodOrder'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '会员套餐',
			userType: '2',
			url: '/memberPkg',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'Member'
		}, {
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '会员订单',
			userType: '2',
			url: '/memberOrder',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'MemberOrder'
		}]
	}, {
		menuId: 2,
		parentId: 0,
		parentName: null,
		name: '记账本',
		url: '',
		perms: null,
		type: 1,
		level: 1,
		icon: 'ios-pricetags',
		orderNum: 0,
		list: [{
			menuId: 2,
			parentId: 0,
			parentName: null,
			name: '分类管理',
			url: '/bookTag',
			perms: null,
			type: 1,
			level: 1,
			icon: 'ios-pricetags',
			orderNum: 0,
			component: 'CashBook'
		}]
	},
]

export {
	components,
	menus,
	generateRoute,
	handleMenus,
	fixedMenus
}
